var fogDepthAdjustPS = `
#ifndef PCFOG
#define PCFOG
uniform vec3 fog_color;
uniform float fog_density;
uniform float fog_start;
uniform float fog_end;
float dBlendModeFogFactor = 1.0;
vec3 addFog(vec3 color) {
	float depth = gl_FragCoord.z / gl_FragCoord.w;
	float adjustedDepth = max(depth - fog_start, 0.0);
	float fogFactor = exp(-adjustedDepth * adjustedDepth * fog_density * fog_density * fog_density * fog_density);
	fogFactor = clamp(fogFactor, 0.0, 1.0);
	return mix(gammaCorrectInput(fog_color)* dBlendModeFogFactor, color, fogFactor);
}
#endif
`;

export { fogDepthAdjustPS as default };
